export const PAGE_SIZE = 8;
export const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const MODAL_WIDTH = 430;
export const DELETE_MODAL_WIDTH = 412;
export const PDF_CONTENT_TYPE = "application/pdf";
export const COMPANY_DOCUMENTS_QUERY_KEY = ["company-documents"] as const;
